export const isNullOrEmpty = (obj) => {
  return obj === '' || obj === null || obj === undefined
}
